import React, {Component} from 'react'
import {connect} from 'react-redux'
import {compose} from 'recompose'
import WithAjax from '../common/helpers/WithAjax'
import {clearVacancyCandidates, fetchVacancyCandidatesSuccess, fetchVacancyOverviewSuccess} from '../../actions/pages/vacancy-page'
import Table from '../../tables/reactable/DefaultTable'
import StatusBadge from '../common/helpers/StatusBadge'
import ProtectedElement from '../common/helpers/ProtectedElement'

class History extends Component {
  constructor() {
    super()
    this.onChangeItemsPerPage = this.onChangeItemsPerPage.bind(this)
    this.state = {
      itemsPerPage: 10,
      items: []
    }
  }

  componentDidMount() {
    this.setState({
        columns: [
        'Status',
        'StatusModifiedDate',
        'StatusModifiedBy'
      ],
      columnNames: [
        'Status',
        'Date',
        'Modified By'
      ]
    });

    let url = 'voicetests/' + this.props.voiceTestId + '/statusHistory'

    this.props.ajax.get(url, true, (data) => {
      this.setState({
        items: Array.from(data)
      })
    });
  }

  onChangeItemsPerPage(e) {
    e.preventDefault()
    this.setState({
      itemsPerPage: e.target.value
    })
    return false
  }


  render() {
    let items = this.state.items.map(item => {
      return Object.assign({}, item, {
        Status: (<StatusBadge status={item.Status.toLowerCase()} statusLabel={item.StatusLabel} />),
        StatusModifiedDate: (<span statusmodifieddate={item.StatusModifiedDate}>{item.StatusModifiedDateAsString}</span>)
      })
    });

    return (
      <div>
        <Table
          items={items}
          columns={this.state.columns}
          columnNames={this.state.columnNames}
          itemsPerPage={this.state.itemsPerPage}
          searchVisible={false}
          onChangeItemsPerPage={this.onChangeItemsPerPage}
          openBtnVisible={false}
          sortable={[
            {
              column: 'StatusModifiedDate',
              sortFunction: function(a, b) {
                return a.props ? a.props.statusmodifieddate.localeCompare(b.props.statusmodifieddate):0;
              }
            }
          ]}
          defaultSort={{column: 'StatusModifiedDate', direction: 'desc'}}
        />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
})
const mapDispatchToProps = dispatch => ({
})
export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  WithAjax)(History)
